const VERSION = '3.1.0';
export function getVersionString() {
    return VERSION;
}
